export default "__VITE_ASSET__CmV$u0Md__"